exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".studyflix-player-container{position:relative;width:100%;height:0;padding-bottom:56.25%}.studyflix-player-container .studyflix-player{position:absolute;width:100%}.studyflix-error__thumbnail{width:100%}.studyflix-error__message{margin-top:16px}", ""]);
